import type { ApplicationSetting } from "@/settings/applicationSetting";
import { getApplicationSettings } from "@/settings/applicationSettingsApi";
import { ref } from "vue";

let loadPromise: Promise<Map<string, ApplicationSetting>> | null = null;
const settingsByKey = ref<Map<string, ApplicationSetting> | null>(null);

const toMap = (items: ApplicationSetting[]) => new Map(items.map((item) => [item.key, item]));

export const ensureApplicationSettings = async () => {
  if (settingsByKey.value) return settingsByKey.value;
  if (!loadPromise) {
    loadPromise = getApplicationSettings()
      .then((response) => {
        const map = toMap(response.data?._items ?? []);
        settingsByKey.value = map;
        return map;
      })
      .catch((error) => {
        loadPromise = null;
        throw error;
      });
  }
  return loadPromise;
};

export const prefetchApplicationSettings = () => {
  void ensureApplicationSettings().catch((error) => {
    console.error("Unable to load application settings", error);
  });
};

export const useApplicationSettings = () => {
  const isLoaded = ref(settingsByKey.value != null);

  ensureApplicationSettings()
    .then(() => {
      isLoaded.value = true;
    })
    .catch(() => {
      isLoaded.value = true;
    });

  const getSetting = (key: string) => settingsByKey.value?.get(key);

  return {
    settingsByKey,
    isLoaded,
    getSetting,
  };
};
